import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { Link } from "src/components/TextV2/Link.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import {
  DEMO_SHOP_REGISTER_HANDLER_URL,
  DEMO_SHOP_REGISTER_SUPPLIER_URL,
} from "src/common/constants.ts";
import { AlertV2 } from "src/components/AlertV2/AlertV2.tsx";
import { Flex } from "src/components/Flex.tsx";
import { Pulsate } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/DemoShopWarning/Pulsate/Pulsate.tsx";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";

export const DemoShopWarning = observer(() => {
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);
  const store = useExonnHubStore();
  const refInterval = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    refInterval.current = setInterval(() => {
      store.drawAttentionToWarning({
        shake: 750,
      });
    }, 10_000);

    return () => {
      if (refInterval.current) {
        clearInterval(refInterval.current);
      }
    };
  });

  return (
    <Pulsate
      intense={store.intensivelyPulsateWarning}
      shake={store.isWarningShaking}
      style={{
        marginLeft: "15px",
        marginRight: "15px",
        marginTop: "15px",
        borderRadius: "6px",
      }}
    >
      <AlertV2 severity={"warning"} pulsateIcon={true}>
        <Flex
          style={{
            flexWrap: "wrap",
          }}
        >
          <TextV2
            style={{
              flexShrink: 0,
              marginRight: 30,
            }}
            variant={"body1"}
          >
            {t("demoShopWarning.registerHandlerText")}{" "}
            <Link
              onClick={() => {
                window.open(DEMO_SHOP_REGISTER_HANDLER_URL, "_newtab");
              }}
              variant={"body1"}
            >
              {t("demoShopWarning.registerHandlerAction")}
            </Link>
          </TextV2>
          <TextV2
            style={{
              flexShrink: 0,
            }}
            variant={"body1"}
          >
            {t("demoShopWarning.registerSupplierText")}{" "}
            <Link
              onClick={() => {
                window.open(DEMO_SHOP_REGISTER_SUPPLIER_URL, "_newtab");
              }}
              variant={"body1"}
            >
              {t("demoShopWarning.registerSupplierAction")}
            </Link>
          </TextV2>
        </Flex>
      </AlertV2>
    </Pulsate>
  );
});
